export const FINANCE = 'finance';
export const MARKETING = 'marketing';
export const SALES = 'sales';
export const CUSTOMER_SERVICE = 'customer-service';
export const PRODUCTIVITY = 'productivity';